import { instance } from '@/apis/core';

import { DetailedOrderLine } from '../orders/types';

import { CreateReivewPayload, ReviewResponse } from './types';
interface ReviewRepositoryImpl {
  createReview(orderline_number: string, payload: CreateReivewPayload): Promise<void>;
  getReview(review_id: string): Promise<ReviewResponse>;
  editReview(review_id: string, payload: CreateReivewPayload): Promise<void>;
  getReviewableOrderlines(order_group_number: string): Promise<DetailedOrderLine[]>;
}

class ReviewRepository implements ReviewRepositoryImpl {
  // 리뷰 작성
  createReview = async (orderline_number: string, payload: CreateReivewPayload) => {
    await instance.post(`/customer/orderlines/${orderline_number}/reviews`, payload);
  };
  // 리뷰 상세 조회
  getReview = async (review_id: string): Promise<ReviewResponse> => {
    const { data } = await instance.get(`/customer/reviews/${review_id}`);
    return data;
  };
  // 리뷰 수정
  editReview = async (review_id: string, payload: CreateReivewPayload) => {
    await instance.put(`/customer/reviews/${review_id}`, payload);
  };
  // 리뷰 작성 가능한 주문 상품 조회
  getReviewableOrderlines = async (order_group_number: string): Promise<DetailedOrderLine[]> => {
    const { data } = await instance.get(
      `/customer/order-groups/${order_group_number}/reviewable-orderlines`,
    );
    return data;
  };
}

export const review = new ReviewRepository();
